import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type RootState } from '../../../../app/store'

export interface UnlinkAction {
  instructionId: number
  checked: boolean
}

export interface ExchangeInstructionsModuleState {
  // currentDisbursementBatchId: number | null
  showAllBatches: boolean
  unlinkActions: UnlinkAction[]
}

const initialState: ExchangeInstructionsModuleState = {
  // currentDisbursementBatchId: null
  showAllBatches: false,
  unlinkActions: []
}

export const exchangeInstructionsSlice = createSlice({
  name: 'exchangeInstructionsSlice',
  initialState,
  reducers: {
    // setCurrentDisbursementBatchId: (state, action: PayloadAction<number>) => {
    //   state.currentDisbursementBatchId = action.payload
    // }
    setShowAllBatches: (state, action: PayloadAction<boolean>) => {
      state.showAllBatches = action.payload
    },
    setUnlinkActions: (state, action: PayloadAction<UnlinkAction[]>) => {
      state.unlinkActions = action.payload
    }

  }
})

export const {
  // setCurrentDisbursementBatchId
  setShowAllBatches,
  setUnlinkActions
} = exchangeInstructionsSlice.actions

// export const selectCurrentDisbursementBatchId = (state: RootState): number | null => state.exchangeInstructionsSlice.currentDisbursementBatchId
export const selectShowAllBatches = (state: RootState): boolean => state.exchangeInstructionsSlice.showAllBatches
export const selectUnlinkActions = (state: RootState): UnlinkAction[] => state.exchangeInstructionsSlice.unlinkActions

export default exchangeInstructionsSlice.reducer
